import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  tab: {
    backgroundColor: theme.palette.primary.dark,

    '& .MuiTab-root': {
      color: theme.palette.primary.contrastText,
      minWidth: theme.isMobile ? 'auto' : 160,
    },

    '& .MuiTabs-indicator': {
      backgroundColor: theme.palette.secondary.main,
    }
  },
  content: {
    maxWidth: theme.breakpoints.values['content'],
    margin: 'auto',
    textAlign: 'left',
  },
  noPad: {
    padding: '0 !important',
  },
  hideMobile: {
    [theme.breakpoints.down('lg')]: {
      display: 'none',
    },
  },
  onlyMobile: {
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
  },
}));

export default useStyles;
